export class StringUtils {
  /**
   * Extracts initials from a display name.
   * Takes the first letter of up to the first two words.
   * Splits on whitespace and hyphens to handle names like "Jean-Claude".
   * Filters out non-letter characters before extracting initials (BOC-524).
   *
   * @example
   * StringUtils.getInitials('John Doe') // 'JD'
   * StringUtils.getInitials('Alice') // 'A'
   * StringUtils.getInitials('John Michael Doe') // 'JM'
   * StringUtils.getInitials('(Aiden) Zucker') // 'AZ'
   * StringUtils.getInitials('123Mike Smith') // 'MS'
   * StringUtils.getInitials('Jean-Claude Van Damme') // 'JC'
   */
  static getInitials(displayName: string): string {
    return displayName
      .trim()
      .split(/[\s-]+/)
      .map((word) => word.replace(/[^a-zA-Z]/g, ""))
      .filter(Boolean)
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);
  }

  /**
   * Initials, or `?` when the name yields none — a stored name of digits or
   * punctuation leaves an avatar with nothing to render.
   */
  static getInitialsOrPlaceholder(displayName: string): string {
    const initials = StringUtils.getInitials(displayName);
    return initials === "" ? "?" : initials;
  }
}
